import { ActionType, FormListActionType, PageContainer, ProFormInstance } from '@ant-design/pro-components';
import ReleaseEntryStepForm from './ReleaseEntryStepForm';
import ReleasesTable from './ReleasesTable';
import { Button, Collapse, FormListOperation, Modal } from 'antd';
import { createContext, useEffect, useRef, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Atom, atom, useAtom, useAtomValue } from 'jotai';
import { useQuery } from 'react-query';
import NewArtistForm from './NewArtistForm';
import SearchForm from './SearchForm';

// const releasesActionRef = useAtomValue(releasesActionRefAtom);
type PageContext = {
    stepFormRef?: React.MutableRefObject<ProFormInstance>;
    firstFormPageRef?: React.MutableRefObject<ProFormInstance>;
    secondFormPageRef?: React.MutableRefObject<ProFormInstance>;
    // fileUploadFormRef?: React.MutableRefObject<ProFormInstance>;
    listRef?: React.MutableRefObject<FormListActionType>;
    releasesActionRef?: React.MutableRefObject<ActionType>;
    artists?: SelectedArtistsByCategory;
    setArtists?: React.Dispatch<React.SetStateAction<SelectedArtistsByCategory>>;
    trackAction?: ProFormListRowAction;
    setTrackAction?: React.Dispatch<React.SetStateAction<ProFormListRowAction>>;
};

type ProFormListRowAction = FormListOperation & {
    getCurrentRowData: () => any;
    setCurrentRowData: (data: any) => void;
};

// type SelectedArtistsByCategory = {
//     main_artists?: number[];
//     featuring_artists?: number[];
//     composers?: number[];
//     authors?: number[];
//     remixers?: number[];
//     producers?: number[];
//     arrangers?: number[];
//     publishers?: number[];
// };
type SelectedArtistsByCategory = {
    main_artists?: string[];
    featuring_artists?: string[];
    composers?: string[];
    authors?: string[];
    remixers?: string[];
    producers?: string[];
    arrangers?: string[];
    publishers?: string[];
};

export const DDEXPageContext = createContext<PageContext>({});

export const PageContextProvider = ({ children, value }: any) => {
    const stepFormRef = useRef<ProFormInstance>();
    const firstFormPageRef = useRef<ProFormInstance>();
    const secondFormPageRef = useRef<ProFormInstance>();
    // const fileUploadFormRef = useRef<ProFormInstance>();
    const listRef = useRef<FormListActionType>();
    const [artists, setArtists] = useState<SelectedArtistsByCategory>({});
    const [trackAction, setTrackAction] = useState<ProFormListRowAction>();
    const releasesActionRef = useRef<ActionType>();

    // If value is provided, use it instead of the default values
    const contextValue = value || {
        stepFormRef,
        firstFormPageRef,
        secondFormPageRef,
        // fileUploadFormRef,
        listRef,
        releasesActionRef,
        artists,
        setArtists,
        trackAction,
        setTrackAction
    };

    return (
        <DDEXPageContext.Provider value={contextValue}>
            {children}
        </DDEXPageContext.Provider>
    );
};

export const isModalOpenAtom = atom(false);
// const searchParamsAtom = atom({});

// const SearchForm = () => {
//     const [searchParmas, setSearchParams] = useAtom(searchParamsAtom);
//     //... set values here
//     const values = {};
//     onSubmit: setSearchParams(values);
//     return <></>;
// };

// export const allReleasesAtom = atomWithQuery((get) => {
//     const searchparams = {}; //
//     return {
//         queryKey: ['releases', searchparams],
//         queryFn: async ({ queryKey }) => {
//             const response = await axiosApiInstance.get<API.MusicDistribution.MusicRelease[]>(
//                 `/api/products/releases/`,
//                 {
//                     params: {
//                         ...searchparams,
//                         with_label: '',
//                         with_artists: '',
//                         with_track_artists: '',
//                         is_pending: false
//                     }
//                 }
//             );
//             const responseData = response.data ?? [];
//             return responseData;
//         }
//     };
// });
const DDEXMainPage = () => {
    // const atomVal = useAtomValue(allReleasesAtom);
    // const [releasesTable, setReleasesTable] = useState(false);
    // const [digitalAssetsData, setDigitalAssetsData] = useState([]);
    // const [releasesData, setReleasesData] = useState([]);

    // const { data } = atomVal;
    // useEffect(() => {
    //     console.log('data object from AtomWithQuery: ', atomVal);
    // }, [atomVal]);

    const { Panel } = Collapse;

    return (
        <PageContextProvider>
            <PageContainer>
                <SearchForm />
                <ReleasesTable />
            </PageContainer>
        </PageContextProvider>
    );
};

export default DDEXMainPage;
